import { combineReducers } from "redux";
import adminReducer from "./adminReducer";
import customerReducer from "./customerReducer";
import plotReducer from "./plotReducer";

const rootReducer = combineReducers( { 

    admin: adminReducer,
    customer: customerReducer,
    plot: plotReducer

} );

export default rootReducer;